var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("select_branch_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('select_branch_page.form_desc'))
    }
  }), _c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.filter == 'qrcode' ? _c('div', [_vm.showQrCodeScanner ? _c('QRCodeScanner', {
    on: {
      "onScan": _vm.onScan
    }
  }) : _vm._e(), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.result,
      expression: "result"
    }],
    staticClass: "search__input mx-auto w-100 mt-3",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.result
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.result = $event.target.value;
      }
    }
  }), !_vm.showQrCodeScanner ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary mt-3",
    on: {
      "click": function click($event) {
        _vm.showQrCodeScanner = true;
      }
    }
  }, [_vm._v(" 開啟 QR Code 掃瞄器 ")]) : _vm._e()], 1) : !_vm.showLoading && _vm.filter == 'manual' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.result,
      expression: "result"
    }],
    staticClass: "search__input m-auto w-100",
    domProps: {
      "value": _vm.result
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.result = $event.target.value;
      }
    }
  })]) : !_vm.showLoading && _vm.filter == 'liff_scanner' ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.result,
      expression: "result"
    }],
    staticClass: "search__input m-auto w-100",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.result
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.result = $event.target.value;
      }
    }
  }), _c('SharedButton', {
    staticClass: "s-btn-bg-primary mt-3",
    on: {
      "click": function click($event) {
        return _vm.openQRCodeReader();
      }
    }
  }, [_vm._v(" 開啟 QR Code 掃瞄器 ")])], 1) : _vm._e()], 1), _vm.getModuleConfig('select_branch_page.button_text') || _vm.getModuleConfig('select_branch_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary mb-2",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffCouponListRedeemConfirm'
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("select_branch_page.button_text")))]), _c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_vm._v(_vm._s(_vm.getModuleConfig("select_branch_page.cancel_button_text")))])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }